module.exports = __webpack_public_path__ + "montserrat-regular-webfont.08279.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/montserrat-regular-webfont.woff
// module id = ./src/_asset/sources/assets/fonts/woff/montserrat-regular-webfont.woff
// module chunks = main